var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31 33C34.866 33 38 29.866 38 26C38 22.134 34.866 19 31 19C27.134 19 24 22.134 24 26C24 29.866 27.134 33 31 33Z","stroke":"#484848","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M15.3074 29.3882C15.9247 32.3729 19.686 37.2664 19.686 37.2664L31 51L42.314 37.2664C42.314 37.2664 46.0753 32.3729 46.6926 29.3882C47.3099 26.4035 46.993 23.3098 45.782 20.4983C44.571 17.6868 42.5202 15.2837 39.889 13.5931C37.2579 11.9024 34.1645 11 31 11C27.8355 11 24.7421 11.9024 22.111 13.5931C19.4798 15.2837 17.429 17.6868 16.218 20.4983C15.007 23.3098 14.6901 26.4035 15.3074 29.3882Z","stroke":"#484848","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pin.defaultProps = {"width":"62","height":"62","viewBox":"0 0 62 62","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
